// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-50abef73]{transition:transform .4s ease;touch-action:manipulation}.wrapper:hover .content-unit-delete-button[data-v-50abef73]{display:block}.content-unit-delete-button[data-v-50abef73]{padding:0;width:20px;height:20px;border-radius:10px;line-height:20px;color:#fff;position:absolute;border-color:transparent;top:0;right:-10px;left:unset;display:none;z-index:500}.content-unit-delete-button i[data-v-50abef73]{position:relative;top:-2px}", ""]);
// Exports
module.exports = exports;
